export * from './contact-preference.model';
